import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";

import { SREEMenu } from "../../../components/Layout/DepartmentMenu";

import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { fetchData } from "../../../utils/fetchData";
import { getAPIPath, getPageTitle } from "../../../utils/getDomainData";
const SREEPlacements = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.placements, setData);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Placements – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Placements"
          pageName="Placements"
          breadcrumbsClass="breadcrumb-bg"
        />
        <SREEMenu />

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 title="Placements">Placements</h3>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            SCHOOL OF RENEWABLE ENERGY AND ENVIRONMENT, IST
                          </th>
                        </tr>
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            LIST OF PLACEMENTS
                          </th>
                        </tr>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">NAME OF STUDENT</th>
                          <th scope="col">WORKING COMPANY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>{obj?.attributes?.Name_of_Student}</td>
                            <td>{obj?.attributes?.Working_Company}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SREEPlacements;
